
import RadioCardGroup from "../../components/RadioCardGroup"
import AmountSmallAfterDecimal from "../../components/AmountSmallAfterDecimal"
import AvatarIcon from "../../components/AvatarIcon"

import {AVATAR_SHAPE_SQUARE, AVATAR_SIZE_SMALL} from "../../constants/interface"
import { 
    FULFILLMENT_METHOD_PICKUP 
} from "../../constants/payeeOrder"
import {StoreIcon} from "../../constants/serverImages"
import { alphabeticalSort, capitalizeAllWords } from "../../utils/stringUtils"

import { addWaitTimes } from "../../utils/payeeOrderUtils"
import { connect } from "react-redux"
import WaitTime from "../../components/WaitTime"

/**
 * Display the different fulfillment options available to the buyer 
 * and provide useful information by interpreting the response from the delivery api
 */
const OrderingFulfillmentOptions = ({
    value="",
    fulfillmentSettings={},
    onChange=()=>{},
    deliveryCatalogsById={},
    deliveryAvailabilityId="",
    deliveryAvailabilityByPayeeCatalogId={},
    deliverySettlementId="",
    prepTimes={},
    currencySymbol="$",
    currencyText="EC",
}) => {
    //available fulfillment methods
    const fulfillmentOptions = []
    //the availability responses returned by the delivery availability api for each of the delivery catalogs
    prepTimes = typeof prepTimes === "object" ? {...prepTimes} : {}
    prepTimes.avg = prepTimes.avg ? prepTimes.avg : "00:00"
    prepTimes.buffer = prepTimes.buffer ? prepTimes.buffer : "00:10"
    //if delivery is available, add it to the list
    if (fulfillmentSettings.delivery){
        Object.values(deliveryCatalogsById)
              .sort((dA, dB) => alphabeticalSort(dA?.payeeName, dB?.payeeName))
              .forEach(d => {
                  const {payeeName="", payeeLogoImageUrl="", id=""} = d || {}
                  //check whether there is an availability response
                  const availabilityByAreaId = deliveryAvailabilityByPayeeCatalogId[id]
                  const availability = typeof availabilityByAreaId === "object" &&
                                       availabilityByAreaId[deliveryAvailabilityId]
                                       ?
                                       availabilityByAreaId[deliveryAvailabilityId] : null

                  const {deliveryTimes, available:deliveryAvailable, price:deliveryFee} = availability || {}
                  let description = ""
                  if (deliveryTimes && typeof deliveryTimes === "object") {
                    const combinedTimes = addWaitTimes(prepTimes, deliveryTimes)
                    description = <WaitTime label="Arrives in" avg={combinedTimes.avg} buffer={combinedTimes.buffer}/>
                  }
                  fulfillmentOptions.push({
                    label: `Delivery by ${capitalizeAllWords(payeeName)}`,
                    description,
                    id,
                    left: <AvatarIcon name={payeeName} imageUrl={payeeLogoImageUrl} shape={AVATAR_SHAPE_SQUARE} size={AVATAR_SIZE_SMALL} />,
                    right: !deliverySettlementId ? <div>Choose a delivery location</div> :
                           !deliveryAvailable && typeof deliveryAvailable === "boolean" ? <div className="badge error">Service unavailable</div> :
                           //if the delivery is not unavailable, but a delivery fee is not yet set 
                           // (the api could have not yet returned the response)
                           typeof deliveryFee !== "number" ? null :
                           <div>{currencyText}{currencySymbol}<AmountSmallAfterDecimal amount={deliveryFee}/></div>
                })
              })
    }
    //if pickup is available, or delivery is unavailable, add pickup - always add it last
    if (fulfillmentSettings.pickup || !fulfillmentSettings.delivery){
        fulfillmentOptions.push({
            label: "Pickup",
            description: <WaitTime label="Ready in" avg={prepTimes.avg} buffer={prepTimes.buffer}/>,
            id: FULFILLMENT_METHOD_PICKUP,
            left: <img src={StoreIcon} height={54} width={54} />,
            right: <span>Free</span>
        })
    }
    return (
        <RadioCardGroup 
            options={fulfillmentOptions}
            selectedValue={value}
            onChange={onChange}
        />
    )
}

const mapStateToProps = state => ({
    deliveryAvailabilityByPayeeCatalogId: state.payeeCatalogs.deliveryAvailabilityByPayeeCatalogId,
})
export default connect(mapStateToProps)(OrderingFulfillmentOptions)